import React, { Component, getGlobal } from "reactn";
import PropTypes from "prop-types";
import { Icon } from "@material-ui/core";

import { _, $ } from "js/vendor";
import { ds } from "js/core/models/dataService";
import { app } from "js/namespaces";
import { AssetType } from "common/constants";
import { trackActivityViaParams } from "js/core/utilities/utilities";
import {
    BlueButton, Divider,
    UIContainer, UINavigation,
    UINavigationItem, UIPane,
    UIPaneContents, UIPaneHeader
} from "js/react/components/UiComponents";
import { Gap30 } from "js/react/components/Gap";
import IconsPane from "js/react/views/AddAssets/Panes/IconsPane";
import LoadingPane from "js/react/views/AddAssets/Panes/LoadingPane";
import { StockPhotosPane } from "js/react/views/AddAssets/Panes/StockPhotosPane";
import LogosPane from "js/react/views/AddAssets/Panes/LogosPane";
import RecentlyUsedAssetsPane from "js/react/views/AddAssets/Panes/RecentlyUsedAssetsPane";
import PresentationAssetsPane from "js/react/views/AddAssets/Panes/PresentationAssetsPane";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { Key } from "js/core/utilities/keys";

import "css/add-assets.scss";
import { PresentationLibraryPane } from "js/editor/PresentationLibrary/PresentationLibrary";
import { StockVideosPane } from "js/react/views/AddAssets/Panes/StockVideosPane";
import { ImportMediaDialog } from "../ImportVideo/ImportMediaDialog";
import * as geom from "js/core/utilities/geom";
import { TeamAssetsPane } from "js/editor/TeamResources/TeamAssetsPane";
import { UIController } from "js/editor/dialogs/UIController";
import { UIActionType, isUIActionRestricted } from "js/core/uiActionsRestrictors";
import { FeatureType } from "common/features";
import ProBadge from "js/react/components/ProBadge";
import { UpgradePlanDialogType } from "../MarketingDialogs/UpgradePlanDialog";

class AddAssetsContainer extends Component {
    lockSlide = true;

    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            userFolders: null,
        };

        switch (props.assetType) {
            case AssetType.ICON:
                this.state.selectedPaneId = "icons";
                break;
            case AssetType.LOGO:
                this.state.selectedPaneId = "logos";
                break;
            case AssetType.VIDEO:
            case AssetType.STOCK_VIDEO:
                if (app.user.features.isFeatureEnabled(FeatureType.WORKSPACE_CAN_ACCESS_STOCK_LIBRARIES, app.appState.workspaceId)) {
                    this.state.selectedPaneId = "stock-videos";
                } else {
                    this.state.selectedPaneId = "team-assets";
                }
                break;
            case AssetType.IMAGE:
            default:
                if (app.user.features.isFeatureEnabled(FeatureType.WORKSPACE_CAN_ACCESS_STOCK_LIBRARIES, app.appState.workspaceId)) {
                    this.state.selectedPaneId = "stock-photos";
                } else {
                    this.state.selectedPaneId = "team-assets";
                }
                break;
        }

        this.imageChooserRef = React.createRef();
        this.logoChooserRef = React.createRef();
        this.stockMediaRef = React.createRef();

        $(window).on("keydown", event => {
            if (event.which == Key.ESCAPE) {
                this.handleBackButton();
            }
        });
    }

    handleBackButton = () => {
        if (this.state.selectedPresentationId) {
            this.setState({
                selectedPaneId: "select-presentation",
                selectedPresentationId: null
            });
            return;
        }
        this.setState({ isOpen: false });
    };

    closeContainer = () => {
        this.props.closeDialog();
    };

    processAsset = (asset, isNew) => {
        const {
            selectedPaneId,
        } = this.state;
        const {
            callback,
            bindTo = "content_value",
        } = this.props;
        let {
            type,
            url,
            previewUrl,
            id,
            size,
            assetProps,
        } = asset;

        if (!size) {
            size = new geom.Size(asset.get("w"), asset.get("h"));
        }

        const trackParams = {
            selectedPaneId,
        };
        if (type === AssetType.IMAGE) {
            trackParams.category = "Image";
        }
        if (type === AssetType.LOGO) {
            trackParams.category = "Logo";
        }
        if (type === AssetType.VIDEO || type === AssetType.STOCK_VIDEO) {
            trackParams.category = "Video";
        }
        trackParams.action = trackParams.action || "Added";
        trackActivityViaParams(trackParams);

        const model = {
            content_type: type,
            content_url: null,
            assetProps: _.merge({}, assetProps, {
                originalSize: size,
            }),
        };
        model[bindTo] = id;

        if (type === AssetType.STOCK_VIDEO) {
            model.content_url = url;
            model.previewUrl = previewUrl;
        }

        callback(model, isNew);
    }

    handleSelectNewAsset = asset => {
        if (this.state.isAlreadyClicked) return;
        this.setState({
            isAlreadyClicked: true
        });
        this.processAsset(asset, true);
    };

    handleSelectExistingAsset = asset => {
        if (this.state.isAlreadyClicked) return;
        this.setState({
            isAlreadyClicked: true
        });
        this.processAsset(asset, false);
    };

    importAsset = async () => {
        const {
            backgroundVideoOnly = true,
            overwriteAssetId,
            hideVideos
        } = this.props;
        ShowDialog(ImportMediaDialog, {
            imageAsLogo: this.state.selectedPaneId === "logos",
            backgroundVideoOnly,
            overwriteAssetId,
            imageOnly: hideVideos,
            onAccept: asset => {
                this.processAsset(asset, true);
                this.closeContainer();
            }
        });
    }

    handleCopyAssetPresentationClicked = presentation => {
        this.setState({
            selectedPaneId: "select-presentation-asset",
            selectedPresentation: presentation.presentationModel
        });
    };

    deselectUserFolder = () => {
        this.setState({
            selectedSecondaryId: null
        });
    };

    renderSelectedPane = () => {
        let {
            selectedPaneId,
            selectedPresentation,
            prefilledSearchQuery,
        } = this.state;
        const {
            backgroundVideoOnly = true,
            overwriteAssetId,
            hideVideos,
            hidePhotos,
            hideLogos,
        } = this.props;

        const { lastLogoSearchTerm } = getGlobal();
        if (selectedPaneId === "logos" && lastLogoSearchTerm) {
            selectedPaneId = "search-logos";
        }

        const assetTypes = [
            !hidePhotos && AssetType.IMAGE,
            !hideLogos && AssetType.LOGO,
            !hideVideos && AssetType.VIDEO,
            !hideVideos && AssetType.STOCK_VIDEO
        ].filter(val => val);

        switch (selectedPaneId) {
            case "recently-used-media":
                return (
                    <RecentlyUsedAssetsPane
                        key="recently-used-media"
                        assetTypes={assetTypes}
                        showSearch={false}
                        backgroundVideoOnly={backgroundVideoOnly}
                        workspaceId={UIController.getWorkspaceId()}
                        addAssetCallback={this.handleSelectExistingAsset}
                        handleConfirm={this.closeContainer}
                        handleSearch={query => {
                            this.setState({
                                selectedPaneId: AssetType.IMAGE,
                                selectedSecondaryId: "stock_photos",
                                prefilledSearchQuery: query
                            });
                        }}
                    />
                );
            case "icons":
                return (
                    <IconsPane
                        addAssetCallback={this.handleSelectExistingAsset}
                        handleConfirm={this.closeContainer}
                        workspaceId={UIController.getWorkspaceId()}
                        searchType="icons"
                    />
                );
            case "logos":
                return (
                    <RecentlyUsedAssetsPane
                        key="logos"
                        assetTypes={[AssetType.LOGO]}
                        showSearch={true}
                        searchPrompt="Search for logos..."
                        addAssetCallback={this.handleSelectExistingAsset}
                        handleConfirm={this.closeContainer}
                        handleSearch={query => {
                            this.setState({
                                selectedPaneId: "search-logos",
                                prefilledSearchQuery: query
                            });
                        }}
                    />
                );
            case "stock-photos":
                return (
                    <StockPhotosPane
                        ref={this.stockMediaRef}
                        overwriteAssetId={overwriteAssetId}
                        addAssetCallback={this.handleSelectNewAsset}
                        handleConfirm={this.closeContainer}
                        prefilledSearchQuery={prefilledSearchQuery}
                        onPrefilledSearchQueryComplete={() => {
                            this.setState({
                                prefilledSearchQuery: null
                            });
                        }}
                    />
                );
            case "stock-videos":
                return (
                    <StockVideosPane
                        ref={this.stockMediaRef}
                        overwriteAssetId={overwriteAssetId}
                        addAssetCallback={this.handleSelectNewAsset}
                        handleConfirm={this.closeContainer}
                        prefilledSearchQuery={prefilledSearchQuery}
                        onPrefilledSearchQueryComplete={() => {
                            this.setState({
                                prefilledSearchQuery: null
                            });
                        }}
                    />
                );
            case "search-logos":
                return (
                    <LogosPane
                        overwriteAssetId={overwriteAssetId}
                        addAssetCallback={this.handleSelectNewAsset}
                        handleConfirm={this.closeContainer}
                        prefilledSearchQuery={prefilledSearchQuery}
                        resetPreviouslyViewedState={() => {
                            this.setState({ selectedPaneId: "logos" });
                            this.renderSelectedPane();
                        }}
                        onPrefilledSearchQueryComplete={() => {
                            this.setState({
                                prefilledSearchQuery: null
                            });
                        }}
                    />
                );
            case "select-presentation":
                return (
                    <UIPane>
                        <UIPaneHeader>Choose a presentation to copy assets from</UIPaneHeader>
                        <UIPaneContents>
                            <PresentationLibraryPane
                                workspaceId={UIController.getWorkspaceId()}
                                collection={ds.presentations}
                                appState={app.appState}
                                readOnly
                                showWorkspaceChooser={false}
                                onSelectedPresentation={this.handleCopyAssetPresentationClicked}
                            />
                        </UIPaneContents>
                    </UIPane>
                );
            case "select-presentation-asset":
                return (
                    <PresentationAssetsPane
                        assetTypes={assetTypes}
                        addAssetCallback={this.handleSelectExistingAsset}
                        handleConfirm={this.closeContainer}
                        selectedPresentation={selectedPresentation}
                        backgroundVideoOnly={backgroundVideoOnly}
                    />
                );
            case "team-assets":
                return (
                    <TeamAssetsPane
                        addAssetCallback={this.handleSelectExistingAsset}
                        handleConfirm={this.closeContainer}
                    />
                );
            default:
                return (<LoadingPane />);
        }
    };

    render() {
        const { isOpen, selectedPaneId } = this.state;

        let {
            hideIcons,
            hideVideos,
            hidePhotos,
            hideLogos,
            hideTeamAssets,
        } = this.props;
        hideIcons = hideIcons || isUIActionRestricted(UIActionType.ADD_ASSET, { assetType: AssetType.ICON });
        hideVideos = hideVideos || isUIActionRestricted(UIActionType.ADD_ASSET, { assetType: AssetType.STOCK_VIDEO });
        hidePhotos = hidePhotos || isUIActionRestricted(UIActionType.ADD_ASSET, { assetType: AssetType.IMAGE });
        hideLogos = hideLogos || isUIActionRestricted(UIActionType.ADD_ASSET, { assetType: AssetType.LOGO });

        return (
            <UIContainer
                isOpen={isOpen}
                className="add-asset-container"
                onClose={this.closeContainer}
            >
                <UINavigation
                    selected={selectedPaneId}
                    onSelect={id => {
                        this.setState({ selectedPaneId: id });
                    }}
                    onBack={this.handleBackButton}
                >
                    <BlueButton onClick={e => this.importAsset()}>
                        <Icon>cloud_upload</Icon>Import...
                    </BlueButton>
                    <Gap30 />
                    {
                        !hideTeamAssets &&
                        <UINavigationItem
                            id="team-assets"
                            title="Team Assets"
                            icon="group"
                            proBadge={
                                <ProBadge
                                    upgradeType={UpgradePlanDialogType.TEAM_NOOP}
                                    show={!app.user.features.isFeatureEnabled(FeatureType.VIEW_LIBRARY_ITEMS, app.appState.workspaceId)}
                                    analytics={{ cta: "TeamAssets", ...ds.selection?.presentation?.getAnalytics() }}
                                    workspaceId={app.appState.workspaceId}
                                />
                            }
                        />
                    }
                    <UINavigationItem
                        id="recently-used-media"
                        title="Recent Media"
                        icon="star_border"
                    />
                    <UINavigationItem
                        id="select-presentation"
                        title="Find in slides"
                        icon="search"
                    />
                    <Divider color="#444" margin={20} />
                    {
                        !hidePhotos &&
                        app.user.features.isFeatureEnabled(FeatureType.WORKSPACE_CAN_ACCESS_STOCK_LIBRARIES, app.appState.workspaceId) &&
                        <UINavigationItem
                            id="stock-photos"
                            title="Stock Photos"
                            icon="camera_alt"
                        />
                    }
                    {
                        !hideVideos &&
                        app.user.features.isFeatureEnabled(FeatureType.WORKSPACE_CAN_ACCESS_STOCK_LIBRARIES, app.appState.workspaceId) &&
                        <UINavigationItem
                            id="stock-videos"
                            title="Stock Videos"
                            icon="video_library"
                        />
                    }
                    {!hideIcons && (
                        <UINavigationItem
                            id="icons"
                            title="Icons"
                            icon="filter_vintage"
                        />
                    )}
                    {!hideLogos && (
                        <UINavigationItem
                            id="logos"
                            title="Logos"
                            icon="sort_by_alpha"
                        />
                    )}
                </UINavigation>
                {this.renderSelectedPane()}
            </UIContainer >
        );
    }
}

AddAssetsContainer.propTypes = {
    assetType: PropTypes.string,
    callback: PropTypes.func
};

export default AddAssetsContainer;
